import clsxm from '@/lib/clsxm';

import Card from '@/components/card';
import { HygraphImageProps } from '@/components/hygraph-image';
import { LinkVariant } from '@/components/link';

import { CardStyle } from '@/enums/card-style';
import { ImageWidth } from '@/enums/image-width';
import { Side } from '@/enums/side';
import { VerticalSide } from '@/enums/vertical-side';
import FeaturedWithLogoPressCard from '@/features/press/components/featured-with-logo-press-card';
import { generatePressCardImage } from '@/features/press/utils/press-utils';
import { formatFullDate } from '@/utils/date-utils';

export type PressCardImageProps = {
  id: string;
  url: string;
  width?: number | null | undefined;
  height?: number | null | undefined;
  description?: string | null | undefined;
  className?: string;
};

type PressCardProps = {
  headline?: string | null | undefined;
  logoImage?: PressCardImageProps | null | undefined;
  publishDate?: string | null | undefined;
  featured?: boolean;
  useLogo?: boolean;
  link?: string | null | undefined;
  pressImage?: HygraphImageProps;
};

export const PressCard = ({
  headline,
  logoImage,
  publishDate,
  featured,
  useLogo,
  link,
  pressImage,
}: PressCardProps) => {
  const formatedPublishDate = publishDate ? formatFullDate(publishDate) : '';
  const pressCardImage = generatePressCardImage(logoImage);

  if (featured && useLogo) {
    if (pressCardImage) {
      pressCardImage.height = 24;
      pressCardImage.imgClassName = 'mt-8 max-w-12';
    }

    return (
      <FeaturedWithLogoPressCard
        pressCardImage={pressCardImage}
        headline={headline}
        formatedPublishDate={formatedPublishDate}
        link={link}
      />
    );
  }

  const pressImagePosition =
    featured && !useLogo ? VerticalSide.TOP : Side.LEFT;
  const pressCardStyle =
    featured && !useLogo ? CardStyle.WHITE_WITH_BORDER : CardStyle.TRANSPARENT;

  if (pressCardImage) {
    if (featured && !useLogo) {
      pressCardImage.imgClassName = clsxm(pressCardImage.imgClassName, 'w-fit');
    } else {
      //pressCardImage.height = 329;
      pressCardImage.imgClassName = clsxm(
        pressCardImage.imgClassName,
        'rounded-lg'
      );
    }
  }

  let pressImageWidth = ImageWidth.AUTO;
  if (pressImage) {
    pressImage.width = 330;

    if (!featured) {
      pressImage.className = clsxm(
        pressImage.className,
        'flex flex-col justify-center'
      );
      pressImage.imgClassName = clsxm(
        pressImage.imgClassName,
        'rounded-lg w-full lg:w-[330px]'
      );
    }

    if (featured) {
      pressImage.imgClassName = clsxm(pressImage.imgClassName, 'w-fit');
      pressImage.draggable = false;
      pressImageWidth = ImageWidth.FULL_WIDTH;
    }
  }

  return (
    <>
      <Card
        cardStyle={pressCardStyle}
        image={useLogo ? pressCardImage : pressImage || undefined}
        caption={formatedPublishDate}
        imagePosition={pressImagePosition}
        imageWidth={pressImageWidth}
        title={headline ?? ''}
        link={{
          href: link || '#',
          children: 'Read More',
          variant: LinkVariant.LINK_WITH_PLUS,
          target: '_blank',
        }}
        className={clsxm('px-0', {
          'flex flex-col md:flex-col lg:flex-row': !featured,
        })}
      />
    </>
  );
};
